import { Card, Tabs, Text } from "@mantine/core";
import { ComponentProps, PropsWithChildren } from "react";
import { useThemeTokens } from "@/src/theme/useThemeTokens";

type TabMenuProperties = ComponentProps<typeof Tabs.Panel> & {
  title: string;
};
const TabPanelMenu = ({ title, children, ...tabPanelProperties }: PropsWithChildren<TabMenuProperties>) => {
  const tokens = useThemeTokens();
  return (
    <Tabs.Panel {...tabPanelProperties}>
      <Card
        p="xs"
        radius="md"
        bg="brand.8"
        style={{
          backgroundColor: tokens.palette.primary[8],
          color: tokens.palette.white[0]
        }}
      >
        <Text c="white.0" fw={700}>
          {title}
        </Text>
      </Card>
      {children}
    </Tabs.Panel>
  );
};

export default TabPanelMenu;
